import React from 'react';

import { EditOrgPage } from './EditOrg';

export function OrgDetails() {
  return <EditOrgPage />;
}
